import styled from 'styled-components';
import { em } from 'polished';
import { Paragraph } from 'elements';
import { colors } from 'core/theme';
import { media, Flex } from 'core/layout';

export const FlexGroup = Flex.extend`
  ${media.tablet`
    display: block;
  `};
`;

export const FiltersList = styled.ul`
  border: 1px solid ${colors.hairline};
  list-style: none;
  padding: 1em 1.5em;

  & > li {
    &:not(:first-child) {
      margin-top: 1em;
    }

    label {
      color: ${colors.subtleText};
    }
  }

  ${media.tabletSmall`
    margin-bottom: 2em;
  `};
`;


export const StyledDescription = styled(Paragraph)`
  font-size: ${em(14)};
`;



// WEBPACK FOOTER //
// ./src/pages/Mekletajs/styled.js